import { useEffect, useState } from "react"
import { FeaturedProject } from "config"
import {
  ArtBlocksTokenMetadata,
  fetchArtBlocksTokenMetadata,
} from "utils/artBlocksMetadataApi"

const useArtBlocksTokenMetadata = (project: FeaturedProject, tokenId?: string) => {
  const [data, setData] = useState<ArtBlocksTokenMetadata | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!tokenId) return

    let cancelled = false
    setLoading(true)
    setError(false)

    fetchArtBlocksTokenMetadata(project, tokenId)
      .then((tokenMetadata) => {
        if (!cancelled) setData(tokenMetadata || null)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [project, tokenId])

  return { data, loading, error }
}

export default useArtBlocksTokenMetadata
